import image from 'img/aside-promo-modal/coverage-campaign.png';
import imageDark from 'img/aside-promo-modal/coverage-campaign-dark.png';
import imageLastCall from 'img/aside-promo-modal/coverage-campaign-last-call.png';
import imageLastCallDark from 'img/aside-promo-modal/coverage-campaign-last-call-dark.png';
import { IS_AUTO_TEST_HIDE, PROMO_TARIFFS } from 'reactApp/appHelpers/configHelpers';
import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import { coverage1tbCampaign, coverageCampaignLastCall } from 'reactApp/appHelpers/featuresHelpers/features/coverage1tbCampaign';
import { PaymentUTM } from 'reactApp/constants/paymentUTM';
import { loadPaidInfoRequest } from 'reactApp/modules/paidInfo/paidInfo.module';
import { handlePaidInfoSuccess } from 'reactApp/modules/paidInfo/paidInfo.saga';
import { PaidInfoSelectors } from 'reactApp/modules/paidInfo/paidInfo.selectors';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { addPromoToShowQueue, promoShown, removePromo } from 'reactApp/modules/promo/promo.module';
import { PromoSelectors } from 'reactApp/modules/promo/promo.selectors';
import { EPromoType } from 'reactApp/modules/promo/promo.types';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { ViewerSelectors } from 'reactApp/modules/viewer/viewer.selectors';
import { getQuotaPromoUrl } from 'reactApp/sections/QuotaLanding/QuotaLanding.data';
import { store as reduxStore } from 'reactApp/store';
import { openAsidePromoModal } from 'reactApp/ui/AsidePromoModal/AsidePromoModal.helpers';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';
import { isDarkThemeModeEnabled } from 'reactApp/utils/theme';
import { put } from 'redux-saga/effects';
import { select } from 'typed-redux-saga';

const PROMO_ID = coverageCampaignLastCall ? 'coverage-campaign-last-call' : 'coverage-campaign';
const PERIOD_IN_DAYS = 3;

// НЕ ИСПОЛЬЗОВАТЬ: в большинстве случаев это приведет к багам
// promoShown должен отправляться в onShow, а removePromo – в onClose
// (и в onClick иногда)
function markPromoShown() {
    reduxStore.dispatch(promoShown(EPromoType.coverageCampaign));
    storeHelper.markAsShown(PROMO_ID);
    reduxStore.dispatch(removePromo(EPromoType.coverageCampaign));
}

export function* initCoverageCampaignAsidePromo() {
    const storage = yield* select(getCurrentStorage);
    const { isHome } = getStorage(storage);
    const isPaidUser = yield* select(UserSelectors.isPaidUser);
    const isCorpUser = yield* select(UserSelectors.isCorpUser);
    const isBizUser = yield* select(UserSelectors.isBizUser);
    const isViewerActive = yield* select(ViewerSelectors.isViewerActive);

    const periodPassed = storeHelper.getValue(PROMO_ID) && storeHelper.isPassed(PROMO_ID, { daysCount: PERIOD_IN_DAYS });

    if (periodPassed) {
        storeHelper.clearStore(PROMO_ID);
    }

    if (!coverage1tbCampaign || !isHome || IS_AUTO_TEST_HIDE || isBizUser || isCorpUser || isPaidUser || storeHelper.getValue(PROMO_ID)) {
        return;
    }

    yield put(loadPaidInfoRequest());

    yield handlePaidInfoSuccess();

    const isUserWithoutPayment = yield* select(PaidInfoSelectors.isUserWithoutPayment);

    if (!isUserWithoutPayment) {
        return;
    }

    const dwhName = coverageCampaignLastCall ? 'mnz_last_call_coverage_campaign' : 'mnz_coverage_campaign';

    yield put(
        addPromoToShowQueue({
            type: EPromoType.coverageCampaign,
            promoId: PROMO_ID,
            onClick: () => {
                markPromoShown();
                sendPaymentGa({
                    action: 'click',
                    eventCategory: ECategoryGa.balloon,
                    name: dwhName,
                    place: isViewerActive ? 'viewer' : 'home',
                });
                emitAnalyticEvent(AnalyticEventNames.ASIDE_COVERAGE_CAMPAIGN_CLICK);
            },
            onShow: () => {
                markPromoShown();
                sendPaymentGa({
                    action: 'show',
                    eventCategory: ECategoryGa.balloon,
                    name: dwhName,
                    place: isViewerActive ? 'viewer' : 'home',
                });
                emitAnalyticEvent(AnalyticEventNames.ASIDE_COVERAGE_CAMPAIGN_SHOW);
            },
            onClose: () => {
                markPromoShown();
                sendPaymentGa({
                    action: 'close',
                    eventCategory: ECategoryGa.balloon,
                    name: dwhName,
                    place: isViewerActive ? 'viewer' : 'home',
                });
            },
        })
    );
}

export function* showCoverageCampaignAsidePromo() {
    const promo = yield* select(PromoSelectors.getPromo(EPromoType.coverageCampaign));

    if (promo) {
        const { onShow, onClick, onClose } = promo;

        const isDarkTheme = isDarkThemeModeEnabled();

        const title = coverageCampaignLastCall ? 'Последние дни акции' : 'Дарим 1 ТБ в Облаке';
        const text = coverageCampaignLastCall
            ? 'Заберите подарок — 1 ТБ на\u00A03\u00A0месяца\u00A0в\u00A0Облаке'
            : 'Сохраните всё, что дорого, с\u00A0подпиской на 3 месяца';
        const buttonText = coverageCampaignLastCall ? 'Успеть' : 'Попробовать';

        let imageUrl = isDarkTheme ? imageDark : image;
        if (coverageCampaignLastCall) {
            imageUrl = isDarkTheme ? imageLastCallDark : imageLastCall;
        }

        const utmString = coverageCampaignLastCall
            ? `${PaymentUTM.coverageCampaignLastCall}&utm_term=18923`
            : `${PaymentUTM.coverageCampaign}&utm_term=18696`;

        yield openAsidePromoModal({
            title,
            text,
            buttonText,
            imageUrl,
            qaId: 'coverage-aside-promo',
            textCompact: true,
            showAboveViewer: true,
            href: getQuotaPromoUrl({
                query: `action=request-payment&productId=${PROMO_TARIFFS.coverageCampaign}&${utmString}`,
            }),
            onShow,
            onClick,
            onClose,
        });
    }
}
